// extracted by mini-css-extract-plugin
export default {"root":"MDTBalance_root__tcAtZ","details":"MDTBalance_details__voyw3","filter":"MDTBalance_filter__JR3O8"};